import { Pipe, PipeTransform } from '@angular/core';
import { DocumentPersonneAvertie, EtatDocumentPa } from '../../../data-domains/document-securite/entities/document-pa.entity';


@Pipe({
	name: 'disablePaField'
})
export class DisablePaFieldPipe implements PipeTransform {

	transform(pa: DocumentPersonneAvertie): boolean {
		if (pa) {
			if (pa.duplicatedId) {
				return false;
			}
			return pa.etat === EtatDocumentPa.SIGNE || pa.etat === EtatDocumentPa.SIGNE_PARTIELLEMENT;
		}
		return false;
	}
}